import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LogoOne from "../../../assets/images/logo.png";
import ForgotPasswordForm from './ForgotPasswordForm';

// Same layout convention as the legacy ForgotPassword.tsx — single centered Card, no carousel
// column. Route this at e.g. /forgot-password (see WEBAPP_ROUTES.md for the router diff).
const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Container fluid>
        <Row>
          <Col
            style={{ position: 'relative', marginTop: '100px' }}
            className='p-0 col-4 form-login'
          >
            <div className='login-wrap'>
              <Card className='h-100 pt-4 pb-5 p-4'>
                <img src={LogoOne} className='logoWidth pb-5' />
                <Card.Header className='cardHeader textLowerCase'>
                  {t('resource_2:forgotPassword')}
                </Card.Header>
                <Card.Body className='p-2 bodyHeightForgot'>
                  <ForgotPasswordForm hasLabel />
                </Card.Body>
                <div className='col-12 fs--1 copyWriteText'>
                  Copyright © EA Technologies 2025. All rights reserved
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPasswordPage;

